module.exports = __webpack_public_path__ + "static/assets/2016a93cfee93ddc2f09c5ba292a97b0.svg";